<template>
    <div class="school-detail-box news-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/school' }">查学校</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/schoolDetail',query: {scl_id:this.scl_id} }">学校详情</el-breadcrumb-item>
            <el-breadcrumb-item>专升本招生快讯详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-detail-content">
			<p>{{newsInfor.title}}</p>
			<div class="news-detail-date">{{newsInfor.times}}</div>
			<div v-html="newsInfor.content" class="news-information"></div>
        </div>
    </div>
</template>

<script>
import { getSpecialNewsDetail } from '@/api/school'
export default {
	data() {
		return {
			id: '',
			scl_id: '',
			newsInfor: '',
		}
	},
	created() {
		this.$store.commit('user/ADDCOUNT', 0);
		this.scl_id = this.$route.query.scl_id;
		this.id = this.$route.query.id;
		this.getNewsDetailHandler();
	},
	methods: {
		getNewsDetailHandler() {
			getSpecialNewsDetail(this.id).then(res => {
				this.newsInfor = res.data;
				
			}).catch(error => {console.log(error);})
		}
	}
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
	.news-detail-content {
		@include gwidth;
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
		padding: 48px 40px;
		margin-top: 24px;
		text-align: center;
		min-height: 400px;
		box-sizing: border-box;
		p {
			font-size: 32px;
			font-weight: 600;
			color: #2c2e33;
			margin: 0;
		}
		.news-detail-date {
			font-size: 14px;
			font-weight: 400;
			color: #909399;
			margin: 24px 0 48px 0;
		}
	}
	.news-information {
		font-size: 16px!important;
		font-weight: 400!important;
		color: #5e6166!important;
		text-align: left!important;
		line-height: 28px!important;
	}
</style>